import ShowerCommon from "./showerCommon";
import {CORNER_SHELVES_POSITIONS} from "../../constants";

export default class BodySpray extends ShowerCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'body_spray';
    this.partName = 'Body Spray';
    this.translateId = "visualizer.bathroom.shower.body_spray";
    this.canBeDisabled = true;
    if (isChild) {
      this.layerPositions = {};
      CORNER_SHELVES_POSITIONS.forEach(pos => {
        this.layerPositions[pos] = null
      })
    }
  }

  load(dbFeature) {
    dbFeature.metaData["layerPosition"] = (dbFeature.metaData["Side"] && dbFeature.metaData["MountPosition"])
      ? dbFeature.metaData["Side"][0] + dbFeature.metaData["MountPosition"][0]
      : CORNER_SHELVES_POSITIONS[0] // should be "" here!!!
    const partNumber = dbFeature.metaData["layerPosition"] === CORNER_SHELVES_POSITIONS[0] ? 1 : 2;
    return super.load_(dbFeature, new this.constructor(false, partNumber),
      true, partNumber === 1 ? 'features' : 'featuresParts');
  }

  handleClick() {
    this.setArmHeadType(); // body spray can be used with everything? not sure
    super.handleClick();
  }

  setLayers(layout) {
    // const showerParent = this.getParent();
    // if (showerParent.shower_head_type !== ShowerHeadTypes.shower_arm || !this.isActiveFeatureGroup("diverterTrim")) {
    //   super.hideLayers();
    //   return;
    // }
    return super.setLayers(layout);
  }

  // getArrayOfConditions() {
  //   const showerParent = this.getParent();
  //   let conditions = super.getArrayOfConditions(); //roomLayout
  //   if (showerParent.handShowerHolder && showerParent.handShowerHolder.activeFeature) {
  //     conditions.push({
  //       propName: "MountPosition",
  //       propValue: showerParent.handShowerHolder.activeFeature.metaData["MountPosition"]
  //         ? showerParent.handShowerHolder.activeFeature.metaData["MountPosition"]
  //         : ["2"]
  //     })
  //   }
  //   return conditions
  // }

}
